import React, {useCallback} from 'react';
import {
    Variation,
    Variations,
} from 'components/customer/Confirmation/Checkout/Variations';
import {useDeleteVariations} from 'components/customer/Confirmation/Checkout/helpers/useDeleteVariations';
import {
    removedBenchIdsSet,
    removedBenchIdsUnset,
    selectRemovedBenchIds,
} from 'components/customer/Confirmation/store/confirmationSlice';
import {useGetBenchVariations} from 'components/customer/Confirmation/Checkout/helpers/useGetVariations';

export const BenchVariations = () => {
    const {deleteVariation, restoreVariation, isDeleted} = useDeleteVariations(
        selectRemovedBenchIds,
        removedBenchIdsSet,
        removedBenchIdsUnset
    );
    const {variations, isLoaded} = useGetBenchVariations();

    const getName = useCallback((variation: Variation) => {
        return (
            <>
                <div>
                    {variation.jobBenchtopNumber}
                    {variation.name}{' '}
                </div>
                <em>({variation.comment})</em>
            </>
        );
    }, []);

    if (!isLoaded || variations.length == 0) return null;

    return (
        <Variations
            getName={getName}
            deleteAction={deleteVariation}
            restoreAction={restoreVariation}
            isDeleted={isDeleted}
            variations={variations}
        />
    );
};
